import React from "react";
import SurveyCondensedTable from "../../../SurveyCondensedTable"
import { NumberFormat, PlaceholderFormat, SelectCombosIBS, AssetTableViewMode } from "../../../../Enums/constants"
import { observer } from "mobx-react";
import { handleHOTChangeLtdPartnership, renderPrivateEquityTotalRow, handleHOTChangeDealTerms, PrivateDealTermsCellRenderer, DealTermCells, handlePrivateTerms } from "./DealTermsTableHandler"
import { getOptionsArray, mandateSubstyleOptions, mandateRegionOptions } from "../../../../ibsHelper";
import ibsStore from "../../../Stores/IbsSurveyStore";
import { getSurveyResponseValue } from "../../../../Helpers/General/SurveyResponsesHelper";

const PrivateDealTermsTable = observer((props) => {
    let currencyPlaceHolderMilsForHeader = `|${PlaceholderFormat.CURRENCY_MILS}|`;

    let mandateLevelInt = null;
    if (typeof ibsStore.checkMandateLevel !== "undefined" && ibsStore.checkMandateLevel !== null) {
        mandateLevelInt = parseInt(ibsStore.checkMandateLevel, 10);
    }
    let avgAssetsGiv = getSurveyResponseValue("IsAvgAssetsGiv");
    const avgAssetsGivNAVTextBR = (mandateLevelInt !== AssetTableViewMode.ASSET_ONLY_VIEW || typeof avgAssetsGiv === "undefined" || avgAssetsGiv === null || avgAssetsGiv == true) ? `avg` : `<br/>year-end`;


    return (
        <SurveyCondensedTable tableName={"PrivateDeals"}
            handleData={handlePrivateTerms}
            handleHOTChange={handleHOTChangeDealTerms}
            cellRenderer={PrivateDealTermsCellRenderer}
            styleOverride={{ marginBottom: '213px' }}
            headers={["PartnershipName", "PartnershipName", "PrivateEquityTypeName", "PrivateEquityRegionName", "DataYear", "IsInCommitmentPeriod", "OriginalCommitmentMil", "UnreturnedInvestmentCapMil", "NetAssetValueMil",
                "FeePercentCommitment", "FeePercentInvestedCap", "FeeBasisDuringCommitmentTypeName", "FeeBasisPostCommitmentTypeName", "CarriedInterestPercent", "HurdleRatePercent", "HurdleRatePercent", "HurdleRatePercent", "HurdleRatePercent", "RowID"]}
            columns={[
                { data: 'fundName', readOnly: true },
                { data: 'holdingNavAvg', readOnly: true },
                { data: 'mandateRegionID', type: 'dropdown', source: mandateRegionOptions() },
                { data: 'subStyleID1', type: 'dropdown', source: mandateSubstyleOptions() },
                { data: 'subStyleID2', type: 'dropdown', source: mandateSubstyleOptions() },
                { data: 'subStyleID3', type: 'dropdown', source: mandateSubstyleOptions() },
                { data: 'vintageYear' },
                { data: 'isInCommitPeriod', type: 'dropdown', source: getOptionsArray(SelectCombosIBS.YES_NO) },
                { data: 'originalCommitmentMil' },
                { data: 'unreturnedInvestmentCapMil' },
                { data: 'commitmentEndYear' },
                { data: 'feePercentCommitment' },
                { data: 'feePercentInvestedCap' },
                { data: 'otherBaseFeebasisDescPriv' },
                { data: 'otherBaseFeeBasisMil' },
                { data: 'feePercentOther' },
                { data: 'carriedInterestPercent' },
                { data: 'hurdleRatePercent' },
                { data: 'rebatePercent' },
                { data: 'RowID'}

            ]}
            cells={DealTermCells}
            trimDropdown={false}
            includeTotalRow
            renderTotalRow={renderPrivateEquityTotalRow}
            colWidths={['250px', '120px', '100px', '120px', '120px', '120px', '80px','80px', '80px', '80px', '80px', '180px', '180px', '80px', '80px', '80px', '80px']}
            canDownload={true}
            formatting={['', NumberFormat.MONEYMILLION, '', '', '', NumberFormat.MONEYMILLION,  NumberFormat.YEAR, NumberFormat.MONEYMILLION,
                NumberFormat.MONEYMILLION, NumberFormat.YEAR, NumberFormat.YEAR, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, '', NumberFormat.MONEYMILLION, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE]}
            nestedHeaders={[
                ['Manager name - Fund name', `Net <br/>asset value <br/>${currencyPlaceHolderMilsForHeader} ${avgAssetsGivNAVTextBR}`,
                    'Region',
                    'Mandate <br/>style',
                    'Mandate <br/>style',
                    'Mandate <br/>style',
                    `Vintage Year`,
                    'Is it in <br/>commit- <br/>ment <br/>period?',
                    `Original Commitment`,
                    `Unreturned Invested Capital <br/>(i.e., book cost)`,
                    'Year when the commitment <br/>period contractually ends?',
                    '% fee on committed amount <br/>(during commitment period) ',
                    '% fee on unreturned invested <br/>capital (post investment period)',
                    'Describe fee basis if <br/>different from committed <br/>capital or unreturned/invested capital',
                    'Provide the fee basis in  <br/>millions, if different from committed capital  <br/>or unreturned/invested capital, and available.',
                    "% fee on the basis <br/>described in the column on the left.",
                    'Carried Interest %',
                    'Hurdle rate before <br/>carried interest',
                    'If available: <br/>Rebate % (LPs share of <br/>transaction fee income)'
                ]
            ]}
            hiddenColumns={getHiddenDealTermsColumns()}
            helpText={['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',]} />
    );

});
export default PrivateDealTermsTable;


const getHiddenDealTermsColumns = () => {
    //let dealTermsYN = getSurveyResponseValue("HasDealTerms")
    let dealTermsYN = true;
    // Always hide RowID
    if (dealTermsYN != 1)
        return [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
    else return [19];
}